<p-dataView [value]="customerService.publicCustomer.value.subscriptions">
    <ng-template let-rec pTemplate="listItem">
        <div class="w-100">
            <div class="d-flex w-100">
                <div class="mx-auto">
                    {{rec.venueName}}
                </div>
            </div>
            <div class="d-flex">
                <div class="ms-1">
                    {{rec.ooMenuItem.name}} {{rec.frequencyDisplayName}}
                </div>
                <div class="ms-auto">
                    {{rec.price | currency}}
                </div>
                
            </div>
            <div class="d-flex">
                <div class="ms-1">
                    Next billing on {{app.moment.unix(rec.nextBillDate).format('l')}}
                </div>
                <fa-icon [icon]='["far","times-octagon"]' size="lg" (click)="onStopSubscription(rec)" class="ms-auto"></fa-icon>
            </div>
        </div>
        
    </ng-template>
    <ng-template pTemplate="empty">
        <div class="d-flex w-100">
            <div class="mx-auto">
                <i>No subscriptions found</i> 😿
            </div>
        </div>
    </ng-template>
</p-dataView>
